export default __webpack_public_path__ + "static/cpf-d8556ab4df020bc23655b01848dbc6c6.png";